import { combineReducers } from 'redux';

import errorReducer from './error.reducer';
import globalStateReducer from './globalState.reducer';
import onlineStateReducer from './online.reducer';
import profileStateReducer from './profile.reducer';
import callStateReducer from './call.reducer';
import livemonitorReducer from './livemonitor.reducer';
import smsemailReducer from './smsemail.reducer';
import chatReducer from './chat.reducer';

export {
  errorReducer,
  globalStateReducer,
  onlineStateReducer,
  profileStateReducer,
  livemonitorReducer,
  callStateReducer,
  smsemailReducer,
  chatReducer,
};

export default combineReducers({
  errorReducer,
  globalStateReducer,
  onlineStateReducer,
  profileStateReducer,
  livemonitorReducer,
  callStateReducer,
  smsemailReducer,
  chatReducer,
});



// WEBPACK FOOTER //
// src/store/reducers/index.js